export default [
	{
		type: "uni",
		id: 1,
		items: [
			{
				id: 1,
				text: "The learning objective was clear to me.",
			},
			{
				id: 2,
				text: "The educational objectives were well defined from the beginning.",
			},
			{
				id: 3,
				text: "The course was well structured and comprehensible.",
			},
			{
				id: 4,
				text: "The structure of the content was logical/easy to follow.",
			},
			{
				id: 5,
				text: "I'm interested in the topic of the course",
			},
			{
				id: 6,
				text: "The topic of the course is relevant.",
			},
			{
				id: 7,
				text: "I believe that I have learned important facts in this course.",
			},
			{
				id: 8,
				text: "The topic of the course is relevant for the work of a psychologist.",
			},
		],
	},
	{
		type: "bi",
		id: 2,
		items: [
			{
				id: 9,
				text: "The difficulty of the content was...",
			},
			{
				id: 10,
				text: "The amount of the content was...",
			},
			{
				id: 11,
				text: "The pace of the course was...",
			},
			{
				id: 12,
				text: "The requirements of the course were...",
			},
			{
				id: 13,
				text: "The amount of time required for the course (including preparation and follow-up) was...",
			},
			{
				id: 14,
				text: "Overall, I felt the course to be...",
			},
		],
	},
	{
		type: "uni",
		id: 3,
		items: [
			{
				id: 15,
				text: "The amount of exercises (homework, teamwork, etc.) was adequate.",
			},
			{
				id: 16,
				text: "The exercises deepened my understanding of the contents.",
			},
			{
				id: 17,
				text: "The exercises clarified the relevance of the course´s content.",
			},
			{
				id: 18,
				text: "The exercises made me think the concepts through.",
			},
			{
				id: 19,
				text: "The exercises inspired me to critically reflect the content we discussed.",
			},
			{
				id: 20,
				text: "The exercises motivated me to further occupy myself with the contents of the course.",
			},
			{
				id: 21,
				text: "Overall, this was a good course.",
			},
			{
				id: 22,
				text: "I learned a lot in this course.",
			},
			{
				id: 23,
				text: "The course fulfilled my expectations.",
			},
			{
				id: 24,
				text: "I would recommend the course.",
			},
		],
	},
	{
		type: "text",
		id: 4,
		items: [
			{
				id: 25,
				text: "Further remarks: I especially appreciated",
			},
			{
				id: 26,
				text: "Further remarks: I did not like",
			},
			{
				id: 27,
				text: "Further remarks: Suggestions for improvements",
			},
		],
	},
	{
		type: "dsp",
		id: 5,
		items: [
			{
				id: 28,
				text: "The lecturer was enthusiastic and motivated.",
			},
			{
				id: 29,
				text: "The lecturer provided a good learning and working atmosphere.",
			},
			{
				id: 30,
				text: "The lecturer has always been well prepared.",
			},
			{
				id: 31,
				text: "The lecturer was able to put complicated ideas across.",
			},
		],
	},
];
